export function stripTags(text: string) {
  return text.replace(/(<([^>]+)>)/gi, '').replace(/\r?\n|\r/g, '');
}
